module.exports = __webpack_public_path__ + "img/3 Header Logo.ca115385.png";